export default "__VITE_ASSET__vuvmH111__"